import { render, staticRenderFns } from "./GoToV2Banner.vue?vue&type=template&id=1ca93ade&scoped=true&"
import script from "./GoToV2Banner.vue?vue&type=script&lang=js&"
export * from "./GoToV2Banner.vue?vue&type=script&lang=js&"
import style0 from "./GoToV2Banner.vue?vue&type=style&index=0&id=1ca93ade&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca93ade",
  null
  
)

export default component.exports